import * as Switch from '@radix-ui/react-switch';
import { cn } from '@/lib/utils';

export interface ToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
}

export function Toggle({ checked, onCheckedChange, disabled, id, ...rest }: ToggleProps) {
  return (
    <Switch.Root
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className={cn(
        'h-5 w-9 shrink-0 rounded-full border border-transparent transition-colors',
        'data-[state=unchecked]:bg-surface3',
        'data-[state=checked]:bg-accent',
        'disabled:opacity-50 disabled:cursor-not-allowed',
      )}
      {...rest}
    >
      <Switch.Thumb
        className={cn(
          'block size-4 rounded-full bg-elevated shadow-[var(--shadow-1)] transition-transform',
          'translate-x-0.5 data-[state=checked]:translate-x-[18px]',
        )}
      />
    </Switch.Root>
  );
}
